export default "__VITE_ASSET__DRyrs273__"